export const hardness = [
    { id: 2, name: 'Легкий'  },
    { id: 3, name: 'Средний' },
    { id: 4, name: 'Крепкий' },
];
